var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRank9 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 83,
  height: 103,
  viewBox: "0 0 83 103",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_ddd_1_381)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d_1_381)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M36.992 37.132C36.5 39.3733 36.254 41.232 36.254 42.708C36.254 44.6213 36.6367 46.0153 37.402 46.89C38.222 47.71 39.452 48.12 41.092 48.12C43.4427 48.12 45.274 47.2727 46.586 45.578C47.9527 43.8833 49.046 41.068 49.866 37.132C50.358 34.9453 50.604 32.95 50.604 31.146C50.604 29.4513 50.2487 28.112 49.538 27.128C48.882 26.144 47.6247 25.652 45.766 25.652C44.3447 25.652 43.142 25.9527 42.158 26.554C41.2287 27.1007 40.436 27.8933 39.78 28.932C39.124 29.9707 38.5773 31.2007 38.14 32.622C37.7027 33.9887 37.32 35.492 36.992 37.132ZM32.646 62.47C32.4273 63.3993 32.318 64.3287 32.318 65.258C32.318 66.6247 32.6187 67.6633 33.22 68.374C33.876 69.0847 34.9693 69.44 36.5 69.44C38.0307 69.44 39.3427 69.0847 40.436 68.374C41.584 67.6087 42.5407 66.57 43.306 65.258C44.126 63.946 44.8093 62.388 45.356 60.584C45.9027 58.78 46.3947 56.812 46.832 54.68L47.406 51.892H47.242C45.93 53.368 44.2627 54.5707 42.24 55.5C40.2173 56.3747 37.894 56.812 35.27 56.812C31.2793 56.812 28.4093 55.7733 26.66 53.696C24.9653 51.564 24.118 48.7487 24.118 45.25C24.118 43.282 24.364 41.0953 24.856 38.69C26.2773 31.966 28.8467 26.8273 32.564 23.274C36.2813 19.7207 41.42 17.944 47.98 17.944C50.768 17.944 53.064 18.2993 54.868 19.01C56.7267 19.7207 58.2027 20.732 59.296 22.044C60.3893 23.3013 61.1547 24.8047 61.592 26.554C62.0293 28.3033 62.248 30.2167 62.248 32.294C62.248 34.2073 62.084 36.2573 61.756 38.444C61.428 40.576 61.0453 42.79 60.608 45.086C59.7333 49.186 58.7767 53.1767 57.738 57.058C56.6993 60.8847 55.2507 64.3013 53.392 67.308C51.5333 70.26 49.1007 72.638 46.094 74.442C43.142 76.246 39.2607 77.148 34.45 77.148C32.646 77.148 30.924 76.9567 29.284 76.574C27.644 76.246 26.1953 75.672 24.938 74.852C23.7353 73.9773 22.7513 72.8567 21.986 71.49C21.2753 70.0687 20.92 68.3467 20.92 66.324C20.92 65.7227 20.9473 65.1213 21.002 64.52C21.0567 63.864 21.166 63.1807 21.33 62.47H32.646Z",
  fill: "#FAFAFA"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_ddd_1_381",
  x: -4,
  y: 0.94397,
  width: 86.248,
  height: 101.204,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1_381"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 9
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_1_381",
  result: "effect2_dropShadow_1_381"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 6
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_dropShadow_1_381",
  result: "effect3_dropShadow_1_381"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect3_dropShadow_1_381",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d_1_381",
  x: 16.9199,
  y: 17.944,
  width: 49.3281,
  height: 67.204,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1_381"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1_381",
  result: "shape"
})))));
export default SvgRank9;